import { PhaseTypeEnum, ContractorResourceTypeEnum } from '@vatos-pas/common';

const PHASE_TYPE_MAP: Record<PhaseTypeEnum, ContractorResourceTypeEnum | null> = {
  [PhaseTypeEnum.Materials]: null,
  [PhaseTypeEnum.Garage]: ContractorResourceTypeEnum.Hanger,
  [PhaseTypeEnum.Hanging]: ContractorResourceTypeEnum.Hanger,
  [PhaseTypeEnum.Hang]: ContractorResourceTypeEnum.Hanger,
  [PhaseTypeEnum.Finishing]: ContractorResourceTypeEnum.Finisher,
  [PhaseTypeEnum.Finish]: ContractorResourceTypeEnum.Finisher,
  [PhaseTypeEnum.Spraying]: ContractorResourceTypeEnum.Sprayer,
  [PhaseTypeEnum.Prime]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.InteriorPaint]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.FinalPaint]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.CMBluetape]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.FinalBluetape]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.ExteriorOne]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.ExteriorTwo]: ContractorResourceTypeEnum.Paint,
  [PhaseTypeEnum.Trim1]: ContractorResourceTypeEnum.Trim,
  [PhaseTypeEnum.Trim2]: ContractorResourceTypeEnum.Trim,
  [PhaseTypeEnum.Bump1]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.Bump2]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.Bump3]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.Bump4]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.Bump5]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.DrywallTouchUp1]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.DrywallTouchUp2]: ContractorResourceTypeEnum.Bumper,
  [PhaseTypeEnum.DrywallTouchUp3]: ContractorResourceTypeEnum.Bumper,
};

export function phaseTypeToResourceType(
  phaseType: PhaseTypeEnum,
): ContractorResourceTypeEnum | null {
  return PHASE_TYPE_MAP[phaseType] ?? null;
}
